export class ToastNotification {
  message: string;

  constructor(message: string) {
    this.message = message;
  }
}
